import captcha from './captcha';
import form from './form';
import modal from './modal';
import modalForm from './modal-form';
import modalManager from './modal-manager';
import notification from './notification';

export default {
  captcha,
  form,
  modal,
  modalForm,
  modalManager,
  notification,
};
